import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {BsModalRef} from 'ngx-bootstrap/modal';
import{HhgBookShipmentAccessorialMsgs} from './hhg-shipment-accessorial-additional'
@Component({
    selector: 'app-hhg-shipment-accessorial-additionalinfo',
    templateUrl: './hhg-shipment-accessorial-additionalinfo.component.html',
    styleUrls: ['./hhg-shipment-accessorial-additionalinfo.component.css'],
    standalone: false
})

export class HhgShipmentAccessorialAdditionalinfoComponent implements OnInit {
	shipmentsId: any;
	bookAccessorialId: any;
	hhgMessageForm: UntypedFormGroup;
	hhgBookShipmentAccessorialMsgs: HhgBookShipmentAccessorialMsgs;
	additionalMessageResponse:any;
	redirectedFromBol: any;

	@Input() 
	public accId;

	@Input() 
	public title;

	@Input() 
	public shipmentId;

	@Input() 
	public messageHistoryArray;

	@Output() action = new EventEmitter();

	currentMessage: any;
	messageArray = [];
	//messageHistoryArray = []; 
	constructor(private formBuilder: UntypedFormBuilder,
		private bsModalRef: BsModalRef
		) {
		this.hhgMessageForm = this.formBuilder.group({
			newMessage: new UntypedFormControl('')
		});
	}

	ngOnInit() {
		window.scrollTo(0, 0);
		if (this.redirectedFromBol === true) {
			this.hhgMessageForm.get('newMessage').disable();
		}
	}

	/**
	 * @description save message entered
	 */
	saveMessage() {
		this.currentMessage = new HhgBookShipmentAccessorialMsgs();
		this.currentMessage.bookAccessorialsId = this.accId;
		this.currentMessage.message = this.hhgMessageForm.get('newMessage').value;
		this.action.emit(this.currentMessage); 
		this.bsModalRef.hide();
	}

	/**
	 * @description Retrieve message history for the accessorial code from back-end
	 */
	loadMessageHistory(existingMessages) {
		for(let i = 0; i<existingMessages.length(); i++) {
			this.messageHistoryArray[i] = existingMessages[i].message;
		}
	}

	/**
	 * @description cancel message entered
	 */
	cancelMessage() {
		this.bsModalRef.hide();
	}
	

}
